export default __webpack_public_path__ + "static/media/icon-bw-3.7851bb73.png";